import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { InovaCommonGraphqlApi } from 'inova-front-core/helpers/services/http';

@Component({
  selector: 'inova-annexes-view',
  templateUrl: './annexes-view.component.html',
  styleUrls: ['./annexes-view.component.scss']
})
export class AnnexesViewComponent{

  title="";

  files:any[]=[];

  constructor(@Inject(MAT_DIALOG_DATA) public data: any,
  private inovaCommonGraphqlApi:InovaCommonGraphqlApi) { 
    this.title = this.data.title;
    this.files = this.data.value?.files || [];
    for(let file of this.files){
      delete file.downloading;
    }
  }

  startDownloading(file:any){
    if(!file.downloading){
      file.downloading = true;
      this.inovaCommonGraphqlApi.getTempUrls([file.url]).subscribe((urls:any[])=>{
        if(urls.length>0){
          this.downloadFileByUrl(urls[0], file.fileName);
        }
        file.downloading = false;
      });
    }
  }

  downloadFileByUrl(url: string, name: string) {
    var downloadLink = document.createElement("a");
    downloadLink.href = url;
    downloadLink.target = "_blank";
    downloadLink.download = name;
    downloadLink.click()
  }
}
